import(/* webpackMode: "eager" */ "/my-new-one/components/site-header.tsx")